import Vue from 'vue'

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

Vue.directive('readMore', {
  inserted: function (el) {
    /* eslint-disable no-undef */
    Utils.setOverflowTextMaxLines()
  }
})
